import { LowerCasePipe } from '@angular/common';
import { AfterContentInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NewFeatureDotComponent } from '../../../account-gallery-shared/components/new-feature-dot/new-feature-dot.component';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { ReplacePipe } from '../../../shared/pipes/replace.pipe';

export type StickyFooterItem = {
  text: string;
  icon: string;
  link?: string;
  key?: string;
  newDot?: string;
};

@Component({
  selector: 'app-sticky-footer',
  templateUrl: './sticky-footer.component.html',
  styleUrls: ['./sticky-footer.component.scss'],
  standalone: true,
  imports: [
    ButtonDirective,
    RouterLink,
    RouterLinkActive,
    SvgComponent,
    NewFeatureDotComponent,
    ContextMenuComponent,
    ButtonMenuItemComponent,
    LowerCasePipe,
    ReplacePipe,
  ],
})
export class StickyFooterComponent implements AfterContentInit {
  @Input() items: StickyFooterItem[];
  @Input() selected: string;
  @Output() onItemClick = new EventEmitter();
  mainItems: StickyFooterItem[];
  allItems: StickyFooterItem[];

  ngAfterContentInit() {
    if (this.items.length <= 5) {
      this.mainItems = this.items;
      this.allItems = [];
    } else {
      this.mainItems = this.items.slice(0, 4);
      this.allItems = this.items.slice();
    }
  }

  itemClicked(item: StickyFooterItem) {
    this.onItemClick.emit(item);
  }
}
